import { useEffect, useState } from "react";

export type ViewMode = "tiles" | "list";

const PREFIX = "domaddress.view.";

/** Remembers tile vs list choice in localStorage per page. */
export function useViewMode(storageKey: string): [ViewMode, (mode: ViewMode) => void] {
  const key = PREFIX + storageKey;

  const [mode, setMode] = useState<ViewMode>(() => {
    try {
      const raw = localStorage.getItem(key);
      if (raw === "list" || raw === "tiles") return raw;
    } catch {
      /* ignore */
    }
    return "tiles";
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, mode);
    } catch {
      /* ignore */
    }
  }, [key, mode]);

  return [mode, setMode];
}
